import { action , observable} from "mobx";
import { Url } from "url";
import PredefinedRoute from "../app/enums/PredefinedRoute";
import { RouteDefinition } from "./RouteDefinition";

export class NavigationStore {

    @observable
    public previousRoute?: string;


    @observable
    public activeRoute?: string;

    @observable
    public routes: RouteDefinition[] = [];

    constructor() {

        this.initRoutes();

        window.onpopstate = (_: any) => {
            // NOP
        };

        window.onhashchange = (e: any) => {
            this.initActiveRoute(new URL(e.newURL));
        };

        this.initActiveRoute(new URL(window.location.href));
    }

    @action
    public navigate = (route: string) => {
        const target = this.getRoute(route);

        window.location.hash = target.path;
    }

    @action
    public markAsActive = (route: string) => {
        this.getRoute(route).activated = true;
        this.previousRoute = this.activeRoute;
        this.activeRoute = route;
    }

    @action
    public addRoute = (route: RouteDefinition) => {
        const existingRoute = this.routes.find((p) => p.path === route.path);
        if ( !existingRoute ) {

            this.routes.push(route);
            this.initActiveRoute(new URL(window.location.href));
        }
    }


    public getActiveRoute = () => {

        if (!this.activeRoute) {
            return null;
        }

        const name = this.activeRoute;

        let routeDefinition = this.routes.find((p) => p.name === name);
        if (!routeDefinition) {
            routeDefinition = this.routes.find((r) => r.path.match(name));
            if (!routeDefinition) {
                throw new Error("Can not find route with name:" + name);
            }
        }

        return routeDefinition;
    }

    public getRoute = (name: string) => {

        let routeDefinition = this.routes.find((p) => p.name === name);
        if (!routeDefinition) {
            routeDefinition = this.routes.find((r) => r.path.match(name));
            if (!routeDefinition) {
                throw new Error("Can not find route with name:" + name);
            }
        }

        return routeDefinition;
    }

    private initRoutes = () => {

        this.addRoute({
            activated: false,
            exact: true,
            name: PredefinedRoute.TENANTS,
            path: `#/${PredefinedRoute.TENANTS}`,
        });

        this.addRoute({
            activated: false,
            exact: true,
            name: PredefinedRoute.OPTIONS,
            path: `#/${PredefinedRoute.OPTIONS}`,
        });

        this.addRoute({
            activated: false,
            exact: true,
            name: PredefinedRoute.FEEDBACK,
            path: `#/${PredefinedRoute.FEEDBACK}`,
        });
    }

    private initActiveRoute = (url: Url) => {

        if (url.hash) {
            const hashRoute = this.routes.find((r) => r.path.match(url.hash!));

            if (hashRoute) {
                this.markAsActive(hashRoute.name);
                return;
            }
        }

        if (this.activeRoute) {
            return;
        }

        const defaultRoute = this.routes.find((r) => r.path.startsWith("#/workspace"));

        if (defaultRoute) {
            this.markAsActive(defaultRoute.name);
        }
    }
}

export default new NavigationStore();
